export default {
  SET_AUTHOR_DETAIL(state, payload) {
    state[payload.key] = payload.value;
  },
  SET_AUTHOR_DATA(state, payload) {
    state.authorData = payload;
  },
};
